module.exports = '1.0.3';


//////////////////
// WEBPACK FOOTER
// ./~/sockjs-client/lib/version.js
// module id = 41
// module chunks = 0